import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
//import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import Uploader from 'src/constrains/SingleImageUploader';
import {
  LoadingAnimation,
  // imageSetting,
  loadingImage,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/constant';
import { sectionProps } from 'src/tools/constant';
// import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';

import { editable } from '@/src/tools/contentModulesFieldName';
import { get } from 'lodash';
import { Field, itemWrapperErrorDisplayAdaptor } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { checkLoadingAnimation } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/validator';
import { i18nGet } from 'src/tools/tools';
import { loadingAnimationFields } from '../fields';
import { getEditableStatus } from '../util';

const imageN = [loadingImage];
//const focusN = [...imageN, imageSetting];

const LA = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled } = props;

  return (
    <Wrapper id={LoadingAnimation} breakpoint={breakpoint}>
      <BlockTitle
        id={LoadingAnimation}
        title={getI18n('general.hOCTitle.loadingAnimation')}
        breakpoint={breakpoint}
        onReset={() => {
          props.handleOnSectionReset(loadingAnimationFields, breakpoint);
        }}
        onCopy={() =>
          props.handleOnSectionCopy(loadingAnimationFields, breakpoint)
        }
        headerErrorDependencies={[imageN]}
        validator={(data) => {
          const d = get(data, imageN);
          return checkLoadingAnimation(d);
        }}
      />
      <Section {...sectionProps}>
        <Field
          shouldUpdate={(p, c) => {
            return (
              get(p, `${LoadingAnimation}_${editable}`) !==
              get(c, `${LoadingAnimation}_${editable}`)
            );
          }}>
          {() => {
            return (
              <Field
                name={imageN}
                rules={[
                  {
                    validator: async (rules: any, value: any) => {
                      const res = checkLoadingAnimation(value);

                      const hasError = get(res, 'hasError');
                      const errors = get(res, 'errors');
                      if (hasError) {
                        return Promise.reject(
                          new Error((errors || []).join(',')),
                        );
                        //</ItemWrapper>throw Error((errors || []).join(','));
                      }
                    },
                  },
                ]}>
                {(
                  props,
                  meta,
                  { getFieldValue, setFields, setFieldsValue },
                ) => {
                  const e = itemWrapperErrorDisplayAdaptor(meta);
                  const is_editable = getEditableStatus(
                    getFieldValue,
                    LoadingAnimation,
                    breakpoint,
                  );
                  return (
                    <ItemWrapper
                      title={`${getI18n('general.hOCTitle.loadingAnimation')}`}
                      bottomTitle={`${getI18n(
                        'general.allowedfiletypes',
                      )}: jpeg, gif, png`}
                      size='small'
                      {...e}>
                      <Uploader
                        height={180}
                        disabled={disabled || !is_editable}
                        {...props}
                      />
                    </ItemWrapper>
                  );
                }}
              </Field>
            );
          }}
        </Field>

        {/* <Field
          dependencies={[`${LoadingAnimation}_${editable}`]}
          shouldUpdate={(p, c) => {
            return get(p, imageN) !== get(c, imageN);
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const image = getFieldValue(imageN);
            const is_editable = getEditableStatus(
              getFieldValue,
              LoadingAnimation,
              breakpoint,
            );
            return (
              <Field name={focusN}>
                {(props, meta) => {
                  //const value = props.value;
                  const onChange = props.onChange;
                  return (
                    <FocusPoint
                      image={image}
                      disable={disabled || !is_editable}
                      onChange={(image) => {
                        onChange(get(image, 'image.imageSetting'));
                      }}
                    />
                  );
                }}
              </Field>
            );
          }}
        </Field> */}
      </Section>
    </Wrapper>
  );
};
export default LA;
